import React from 'react';
import { Box, Container, IconButton, Typography } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import { Link } from 'react-router-dom';

const socialLinkStyles = {
  width: 48,
  height: 48,
  color: 'text.primary',
  border: '1px solid rgba(248, 241, 231, 0.28)',
  '&:hover': {
    color: '#0b0909',
    bgcolor: 'secondary.main',
    borderColor: 'secondary.main',
  },
};

function Footer() {
  return (
    <Box component="footer" sx={{ bgcolor: '#070505', borderTop: '1px solid rgba(248, 241, 231, 0.14)' }}>
      <Container maxWidth="xl" sx={{ px: { xs: 2, sm: 3, md: 5 }, py: { xs: 6, md: 8 } }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', md: 'flex-end' },
            gap: 5,
          }}
        >
          <Box>
            <Typography variant="h3" sx={{ fontSize: { xs: '3.25rem', md: '4.25rem' }, lineHeight: 1 }}>
              Malpractice
            </Typography>
            <Typography sx={{ color: 'text.secondary', mt: 1 }}>
              Live entertainment across New Jersey and Pennsylvania.
            </Typography>
            <Box component="nav" aria-label="Footer navigation" sx={{ display: 'flex', gap: 3, mt: 3 }}>
              {[
                ['Home', '/'],
                ['About', '/about'],
                ['Contact', '/contact'],
              ].map(([label, path]) => (
                <Typography
                  key={path}
                  component={Link}
                  to={path}
                  sx={{
                    minHeight: 44,
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'text.primary',
                    fontWeight: 600,
                    textDecorationColor: 'primary.main',
                    textUnderlineOffset: '5px',
                  }}
                >
                  {label}
                </Typography>
              ))}
            </Box>
          </Box>

          <Box>
            <Typography sx={{ color: 'text.secondary', fontSize: '0.875rem', mb: 2 }}>
              Follow the next set
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <IconButton aria-label="Facebook" component="a" href="https://www.facebook.com/MALPracticeShowband" target="_blank" rel="noopener noreferrer" sx={socialLinkStyles}>
                <FacebookIcon />
              </IconButton>
              <IconButton aria-label="Instagram" component="a" href="https://www.instagram.com/malpractice_showband" target="_blank" rel="noopener noreferrer" sx={socialLinkStyles}>
                <InstagramIcon />
              </IconButton>
              <IconButton aria-label="Email" component="a" href="mailto:music@malpractice.band" sx={socialLinkStyles}>
                <EmailOutlinedIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>
        <Typography sx={{ color: 'rgba(248, 241, 231, 0.56)', fontSize: '0.8rem', mt: 6 }}>
          Copyright {new Date().getFullYear()} Malpractice Band
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
